import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-balao-aviso',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './balao-aviso.component.html',
  styleUrl: './balao-aviso.component.css'
})
export class BalaoAvisoComponent {
  @Input({ required: true }) texto = '';
  @Input() largura = '363px';
}
